export default __webpack_public_path__ + "af89e513b470ed02723370e24b16692e.png";